export default __webpack_public_path__ + "static/media/template2.0f9ab299.png";